<template>
    <UiForm ref="form" :data="data" :rules="rules">
        <div class="row">
            <UiFormItem prop="coordinate" :label="$t('Site')">
                <UiInput name="coordinate" v-model="data.coordinate" :width="200" :placeholder="$t('BioTools.VPMPlaceholder1')" @change="changePos" />
            </UiFormItem>

            <UiFormItem prop="oaa" :label="$t('BioTools.OAA')">
                <UiInput name="oaa" v-model="data.oaa" placeholder="" :width="200" :readonly="true" />
            </UiFormItem>

            <UiFormItem prop="naa" :label="$t('BioTools.NAA')">
                <UiSelect
                    name="naa"
                    v-model="data.naa"
                    :classExtraName="css.candidates"
                    @change="changeNaa"
                    :width="200"
                    :height="306"
                    :candidates="naa"
                    :placeholder="$t('BioTools.NAA')">
                    <template #candidate="{ data }">
                        <div :class="css.item">
                            <div :class="css.content">{{ data.value }}</div>
                            <div :class="css.label" v-if="data.shortnanme">{{ data.shortnanme }}</div>
                        </div>
                    </template>
                </UiSelect>
            </UiFormItem>

            <UiFormItem prop="codon" :label="$t('BioTools.Codon')">
                <UiInput
                    name="codon"
                    v-model="data.codon"
                    @change="changeCodon"
                    :width="200"
                    :candidates="candidate"
                    :placeholder="$t('BioTools.VPMPlaceholder2')" />
            </UiFormItem>
        </div>
    </UiForm>
</template>

<script lang="ts" setup>
import { UiForm, UiInput, UiFormItem, UiSelect } from "various-ui";
import { useComposable } from "./src/composable";
import { naa } from "./src/options";
import css from "./style/index.module.less";

const emit = defineEmits<{ (event: "redraw", data: any): void }>();

const { refs, data, rules, methods } = useComposable(emit);

const { form, candidate } = refs;
const { changePos, changeNaa, changeCodon } = methods;

defineExpose({ init: methods.init, submit: methods.submit });
</script>

<style lang="less" scoped>
.ui-form {
    .row {
        display: flex;
        margin-top: 24px;
        justify-content: space-between;
    }
}
</style>
